module.exports = __webpack_public_path__ + "img/google-sheets.27eb2f3c.jpg";